<pr-panel class="margin-simulation-pack">
  <!-- A voir si cela doit rester : <pr-panel-header *ngIf="withPanelTitle" -->
  @if (!choices) {
    <pr-panel-header
      [title]="simulationPackService.template.panelTitle"
    ></pr-panel-header>
  }
  @if (choices) {
    <div class="pr-radio justify-content-center display-m">
      <pr-radio
        [choices]="choiceOptions"
        (onSelectChoice)="
          onChoiceSelected($event, getTypeObject().type, handleFormSubmission)
        "
      >
      </pr-radio>
    </div>
  }
  @if (isAutomatic) {
    <div>
      <pr-panel-body clazz="pal">
        <simulation-packs
          [simulation]="simulation"
          (packSelected)="onPackSelected($event)"
          [withCustomPack]="withCustomPack"
          [withPanelTitle]="withPanelTitle"
          [suitableBaseOnScore]="suitableBaseOnScore"
          [withoutManual]="withoutManual"
        >
        </simulation-packs>
      </pr-panel-body>
    </div>
  }

  @if (isManual && isDisplayManual) {
    <div
      class="d-flex manual justify-content-center align-items-center flex-wrap"
    >
      <div class="choice-text">
        <h4>{{ getTypeObject().title }}</h4>
        <div>
          <p>{{ getTypeObject().content }}</p>
          <p>{{ getTypeObject().subContent }}</p>
        </div>
        <pr-button
          display="neutral"
          label="{{ getTypeObject().labelBtnManual }}"
          size="lg"
          (click)="selectCustomPack(handleFormSubmission, getTypeObject().type)"
        ></pr-button>
      </div>
      <div>
        <img [src]="imgSrc" alt="" />
      </div>
    </div>
  }
</pr-panel>
<ng-content></ng-content>
@if (withTable && isDisplay) {
  @if (selectedPack) {
    <simulation-pack-table
      [simulation]="simulation"
      [canEdit]="true"
    >
    </simulation-pack-table>
  }
  <p class="footer-panel">
    Les performances passées ne préjugent pas des performances futures.
  </p>
}
